import { render } from "./UiLimitPagination.vue?vue&type=template&id=29a7deda&lang=pug"
import script from "./UiLimitPagination.vue?vue&type=script&lang=js"
export * from "./UiLimitPagination.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__